
// // src/components/GuessedWordsModal.js

// import React from "react";
// import { useSelector } from "react-redux";
// import { Modal, Box, Typography, IconButton, LinearProgress, Button } from "@mui/material";
// import CloseIcon from "@mui/icons-material/Close";

// const GuessedWordsModal = ({ open, onClose, guessedWords, totalParticipants = 1 }) => {
//   const buttonColor = useSelector((state) => state.gameSettings.buttonColor);

//   const style = {
//     position: "absolute",
//     top: "50%",
//     left: "50%",
//     transform: "translate(-50%, -50%)",
//     width: 400,
//     bgcolor: "#2A2A2E",
//     borderRadius: 2,
//     boxShadow: 24,
//     color: "white",
//     p: 4,
//   };

//   return (
//     <Modal open={open} onClose={onClose}>
//       <Box sx={style}>
//         <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", mb: 2 }}>
//           <Typography variant="h6">Selected Letters</Typography>
//           <IconButton onClick={onClose} sx={{ color: "white" }}>
//             <CloseIcon />
//           </IconButton>
//         </Box>

//         <Box sx={{ maxHeight: "300px", overflowY: "auto" }}>
//           {guessedWords.length === 0 ? (
//             <Typography variant="body1" sx={{ color: "white", textAlign: "center", mt: 2, mb: 2 }}>
//               There is no letter selected by participants.
//             </Typography>
//           ) : (
//             guessedWords.map(({ word, count, percentage }, index) => (
//               <Box key={index} sx={{ display: "flex", alignItems: "center", marginBottom: 2, marginTop: 1 }}>
//                 <Typography variant="body1" sx={{ marginRight: 1 }}>{word}</Typography>
//                 <Box sx={{ flexGrow: 1, marginRight: 1, position: "relative" }}>
//                   <Typography
//                     variant="body1"
//                     sx={{
//                       position: "absolute",
//                       left: "2%",
//                       top: "50%",
//                       transform: "translateY(-50%)",
//                       color: "white",
//                       zIndex: 1,
//                     }}
//                   >
//                     {count} People
//                   </Typography>
//                   <LinearProgress
//                     variant="determinate"
//                     value={percentage}
//                     sx={{
//                       height: 25,
//                       backgroundColor: "#4f4f4f",
//                       "& .MuiLinearProgress-bar": {
//                         backgroundColor: buttonColor,
//                       },
//                     }}
//                   />
//                   <Typography
//                     variant="body1"
//                     sx={{
//                       position: "absolute",
//                       right: "2%",
//                       top: "50%",
//                       transform: "translateY(-50%)",
//                       color: "white",
//                       zIndex: 1,
//                     }}
//                   >
//                     {percentage.toFixed(2)}%
//                   </Typography>
//                 </Box>
//               </Box>
//             ))
//           )}
//         </Box>

//         <Button onClick={onClose} style={{ backgroundColor: buttonColor, color: 'white', float: 'right', marginTop: '1rem' }}>
//           Close
//         </Button>
//       </Box>
//     </Modal>
//   );
// };

// export default GuessedWordsModal;


import React from "react";
import { useSelector } from "react-redux";
import { Modal, Box, Typography, IconButton, LinearProgress, Button } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";

const GuessedWordsModal = ({ open, onClose,  guessedWords = [], totalParticipants = 1 }) => {
  const buttonColor = useSelector((state) => state.gameSettings.buttonColor);

  // Sort guessedWords in descending order based on count
  const sortedGuessedWords = guessedWords.sort((a, b) => b.count - a.count);

  const style = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: 400,
    bgcolor: "#2A2A2E",
    borderRadius: 2,
    boxShadow: 24,
    color: "white",
    p: 4,
  };

  return (
    <Modal open={open} onClose={onClose}>
      <Box sx={style}>
        <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", mb: 2 }}>
          <span variant="h6">Selected Letters</span>
          <IconButton onClick={onClose} sx={{ color: "white" }}>
            <CloseIcon />
          </IconButton>
        </Box>

        <Box sx={{ maxHeight: "300px", overflowY: "auto" }}>
          {sortedGuessedWords.length === 0 ? (
            <span variant="body1" style={{ color: "white", textAlign: "center", mt: 2, mb: 2 }}>
              There is no letter selected by participants.
            </span>
          ) : (
            sortedGuessedWords.map(({ word, count, percentage }, index) => (
              <Box key={index} sx={{ display: "flex", alignItems: "center", marginBottom: 2, marginTop: 1 }}>
                <span variant="body1" style={{ marginRight: 10 }}>{word}</span>
                <Box sx={{ flexGrow: 1, marginRight: 1, position: "relative" }}>
                  <span
                    variant="body1"
                    style={{
                      position: "absolute",
                      left: "2%",
                      top: "50%",
                      transform: "translateY(-50%)",
                      color: "white",
                      zIndex: 1,
                    }}
                  >
                    {count} Count
                  </span>
                  <LinearProgress
                    variant="determinate"
                    value={percentage}
                    sx={{
                      height: 25,
                      backgroundColor: "#4f4f4f",
                      "& .MuiLinearProgress-bar": {
                        backgroundColor: buttonColor,
                      },
                    }}
                  />
                  <span
                    variant="body1"
                    style={{
                      position: "absolute",
                      right: "2%",
                      top: "50%",
                      transform: "translateY(-50%)",
                      color: "white",
                      zIndex: 1,
                    }}
                  >
                    {percentage.toFixed(2)}%
                  </span>
                </Box>
              </Box>
            ))
          )}
        </Box>

        <button onClick={onClose} style={{ padding:'2%',backgroundColor: buttonColor, color: 'white', float: 'right', marginTop: '1rem',border:'none' ,borderRadius:'10%'}}>
          Close
        </button>
      </Box>
    </Modal>
  );
};

export default GuessedWordsModal;
